var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doughnut-chart"},[_c('canvas',{staticClass:"doughnut-chart__chart",attrs:{"id":("js_doughnutChart" + _vm.chartIndex)}})])}
var staticRenderFns = []

export { render, staticRenderFns }